<template>

    <form class="main-page" @submit.prevent="sendData">

        <div class="main-page-nav">
            <div class="link active">Вход</div>
            <div class="divider">/</div>
            <div class="link"><router-link to="/register">Регистрация</router-link></div>
        </div>

        <material-input v-model="email" :error="errors.email" type="text">E-mail</material-input>

        <div style="position: relative">

            <material-input v-model="password" :error="errors.password" type="password">Пароль</material-input>
            <div id="forget-password">
                <router-link to="/password/reset">Не помню пароль</router-link>
            </div>
        </div>

        <div style="text-align: center">
            <button type="submit">Войти</button>
        </div>

    </form>

</template>


<script>
    import axios from 'axios'
    import materialInput from '../../elements/material-input'

    export  default {
        components: {
            materialInput
        },
        data(){
            return {
                valid: true,
                email: '',
                password: '',
                errors: {
                    email: '',
                    password: '',
                }
            }
        },
        methods: {
            sendData(){
                axios.post('/login',{
                    email: this.email,
                    password: this.password,
                    remember: true,
                }).then((req)=>{
                    this.$store.dispatch('getAuthUser')
                }).catch((req)=>{
                    if(req.response.status === 419){
                        window.location.reload();
                    }
                    let errors = req.response.data.errors;
                    if(errors){
                        this.errors.email = errors.email ? errors.email.join('\n') : '';
                        this.errors.password = errors.password ? errors.password.join('\n') : '';
                    } else {
                        this.errors.email = '';
                        this.errors.password = '';
                    }
                })
            }
        }
    }
</script>
